import React from "react";
import { Link } from "react-router-dom";
import "./blog.css";
import img1 from "../../assets/blog-1.jpg"
import img2 from "../../assets/blog-2.jpg";
import img3 from "../../assets/blog-3.jpg"
import img4 from "../../assets/blog-4.jpg"
import img5 from "../../assets/blog-5.jpg"
import img6 from "../../assets/blog-6.jpg";
import img7 from "../../assets/blog-7.jpg"
import img8 from "../../assets/blog-8.jpg"
import img9 from "../../assets/blog-9.jpg"

function BLOG() {
  const blogs = [
    {
      id: 1,
      image: img1,
      title: "طب أسنان الأطفال: ليه صحة الأسنان اللبنية مهمة؟",
      content: "أسنان الأطفال اللبنية أول ما تظهر، يبقى بداية رحلة طويلة لصحة الفم والأسنان. للأسف، فيه اعتقاد شايع إن الأسنان اللبنية مش مهمة لأنها بتتبدل، لكن الحقيقة إن صحتها بتأثر بشكل مباشر على صحة الأسنان الدائمة وحتى على نمو الفك وطريقة الكلام."
    },
    {
      id: 2,
      image: img2,
      title: "جراحة الأسنان: خلع ضروس العقل ومشاكله",
      content: "ضروس العقل واحدة من أكثر الحاجات اللي بتسبب مشاكل في الأسنان، وكتير من الناس بيضطروا يشيلوها في مرحلة ما من حياتهم. بس ايه اللي بيخلي ضروس العقل تسبب ألم ومشاكل كبيرة كده؟"
    },
    {
      id: 3,
      image: img3,
      title: "زراعة الأسنان: الحل الأمثل لتعويض الأسنان المفقودة",
      content: "كتير من الناس بيفقدوا أسنانهم بسبب حوادث، تسوس، أو أمراض اللثة وده بيأثر على الشكل والقدرة على المضغ. زراعة الأسنان بقت النهاردة الحل الأفضل والأكثر تطورًا لتعويض الأسنان المفقودة."
    },
    {
      id: 4,
      image: img4,
      title: "تجميل الأسنان: ابتسامة هوليوود حلم ولا حقيقة؟",
      content: "الابتسامة المثالية بقت حلم عند كتير من الناس، وده بسبب تأثيره الكبير على الثقة بالنفس والجاذبية. ابتسامة هوليوود، أو ما يُعرف بالـHollywood Smile، هي واحدة من أكثر الإجراءات التجميلية شيوعًا في طب الأسنان."
    },
    {
      id: 5,
      image: img5,
      title: "الحشوات العادية: حل بسيط لمشكلة كبيرة",
      content: "الحشوات السنية من أكثر الاجراءات العلاجية شيوعاً في طب الأسنان. هي الحل المثالي لتعويض الأجزاء المفقودة من الأسنان بسبب التسوس أو الكسر. الحشوات العادية، على الرغم من بساطتها، دورها كبير جداً في الحفاظ على صحة الأسنان ووظيفتها."
    },
    {
      id: 6,
      image: img6,
      title: "حشو العصب: لما الألم يكون شديد الحل في العصب",
      content: "حشو العصب هو واحد من أكثر العلاجات المتقدمة في طب الأسنان، وبيعتبر الحل الوحيد لإنقاذ الأسنان اللي فيها تسوس عميق وصل لجذر السن. الألم الناتج عن التهابات العصب ممكن يكون شديد جداً، لكن مع وجود حشو العصب، الحل بقى أسهل بكتير."
    },
    {
      id: 7,
      image: img7,
      title: "الحشوات التجميلية: حلول عملية لجمال أسنانك",
      content: "الابتسامة المثالية مش بس شكل الأسنان، لكن كمان لونها وتناسقها. الحشوات التجميلية بقت الحل الأمثل لتعويض أي فراغات أو تسوس بأسنانك مع الحفاظ على جمالها. دلوقتي تقدر تصلح سنك التالف من غير ما يبان إنك عملت حاجة."
    },
    {
      id: 8,
      image: img8,
      title: "تركيبات الأسنان: الحل الأمثل لتعويض الأسنان المفقودة",
      content: "فقدان الأسنان مشكلة بتأثر مش بس على الشكل، لكن كمان على القدرة على الأكل والكلام. تركيبات الأسنان هي واحدة من أفضل الحلول لتعويض الأسنان المفقودة، وبتقدم نتائج قريبة جداً للأسنان الطبيعية."
    },
    {
      id: 9,
      image: img9,
      title: "تقويم الأسنان الشفاف: حل عصري وفعال",
      content: "كتير من الناس بيخاف تعمل تقويم الأسنان بسبب الشكل اللي بيظهر بيه التقويم التقليدي. لكن دلوقتي التقويم الشفاف بقى حل مثالي وبيقدم نفس النتائج، مع شكله اللي ما بيتشافش تقريباً."
    }
  ];

  return (
    <div className="blog" id="Blog">
      <div className="container">
        <button>THE BLOG</button>
        <h2 style={{color:'white'}}>تحقق من أخبارنا</h2>
        <div className="parent_carddd">
          {blogs.map((blog) => (
            <div key={blog.id} className="cardd">
              <div className="image">
                <img src={blog.image} alt="" />
              </div>
              <div className="cosmetic" dir="rtl">
                <h3>{blog.title}</h3>
                <p className="blog-preview">{blog.content}</p>
                <div className="button-wrapper">
                  <Link to={`/blog/${blog.id}`} className="blog-link">
                    <button className="learn-more-btn">اعرف اكثر</button>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BLOG;
